// Home Section Data
// Edit this file to update the home section content

export const homeData = {
  name: "Muhammad Affan Burney",
  title: "Cloud & DevOps Engineer",
  subtitle: "Building secure, scalable, and automation-first infrastructure",
  description: "Passionate about building secure, scalable, and automation-first infrastructure across Azure and AWS using Infrastructure as Code and cloud-native services.",
  cta: {
    primary: "View My Work",
    secondary: "Get In Touch"
  },
  social: {
    github: "https://github.com/affan03",
    linkedin: "https://www.linkedin.com/in/affan-burney-056485194/",
    email: "mailto:affanburney03@gmail.com"
  }
};

